import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController, PopoverController, AlertController } from 'ionic-angular';

import { GestaoPcaService } from "../../../providers/gestao-pca-service";
import { CertificadoService } from "../../../providers/certificado-service";
import { AlertService } from "../../../providers/alert-service";
import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";
import { AGORA } from "../../../app/AGORA";
import { UsuarioService } from "../../../providers/usuario-service";
import { ArquivosService } from '../../../providers/arquivos-service';

import { FileService } from '../../../providers/file-service';

/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-modal-autuacao',
    templateUrl: 'modal-autuacao.html',
    providers: [
        AGORA
    ]
})
export class ModalAutuacaoPage {

    autuacao: any = {
        "modulos": [],
        "idPca": 0
    };

    titulo: any;
    PCAAtiva: any;
    listaModulos: any = [];
    comboModulos: any = [];
    isJurisdicionado: any;
    loading: any = true;
    usuarioLogado: any;

    idModuloPCA: any;

    listaArquivosPCA: any;

    objetoRetorno: any = {
        salvar: false,
        periodoFuncao: ''
    };

    processo: any = "";
    tipoDocumento: any;

    constructor(public AGORA: AGORA,
        public popoverCtrl: PopoverController,
        private fileService: FileService,
        private viewCtrl: ViewController,
        public modalCtrl: ModalController,
        public gestaoPcaService: GestaoPcaService,
        public arquivoService: ArquivosService,
        public certificadoService: CertificadoService,
        public alertCtrl: AlertController,
        public navParams: NavParams,
        public alertService: AlertService,
        public usuarioService: UsuarioService) {

        this.usuarioLogado = this.usuarioService.obtemUsuario();

        this.titulo = this.navParams.get('titulo');
        this.tipoDocumento = this.navParams.get('tipoDocumento');
        this.processo = this.navParams.get('processo');

        this.autuacao = {
            "modulos": [],
            "idPca": 0
        };

        this.objetoRetorno = {
            flag: false
        };

        this.PCAAtiva = this.navParams.get('pca');
        this.gestaoPcaService.setPCA(this.PCAAtiva);
        this.carregarModulos();

        this.gestaoPcaService.obterModuloPcaPorPCA(this.PCAAtiva.id).subscribe(next => {

            next.forEach(p => {
                if (p.idModulo == 17) {
                    this.idModuloPCA = p.idModuloPca;
                }
            });

            this.carregarModal();

        });
    }

    carregarModulos() {
        this.gestaoPcaService.listarModulosAutuacao().subscribe(data => {
            this.listaModulos = data;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
            this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os módulos:" + error);
        });
    }

    autuar() {
        this.loading = true;
        if (this.listaArquivosPCA.length == 1) {
            // if (this.listaArquivosPCA[0].assinantes && this.listaArquivosPCA[0].assinantes.length > 0) {
                let json: any = {
                    "idPca": this.PCAAtiva.id,
                    "idArquivoCertificado": this.listaArquivosPCA[0].idArquivoVinculado, //o id do arquivo vinculado do certificado salvo no banco
                    "modulos": this.autuacao.modulos,
                    "nrProcesso": this.processo
                };

                this.certificadoService.autuarCertificado(json).subscribe(data => {
                    this.alertService.mostraAlerta("", "Documentos Incorporados com sucesso! <br /> Nº Processo: " + this.processo);
                    this.objetoRetorno.flag = true;
                    this.viewCtrl.dismiss(this.objetoRetorno);
                }, error => {
                    this.alertService.mostraAlerta("Erro ao incorporar os documentos", error.mensagem);
                    console.log("aqui" + error.mensagem)
                    this.loading = false;
                    console.log("erro: " + error);
                });
            // } else {
            //     this.alertService.mostraAlerta("Erro ao incorporar os documentos", "A assinatura do certificado é obrigatória.");
            //     this.loading = false;
            // }
        } else {
            this.alertService.mostraAlerta("Erro ao incorporar os documentos", "Somente um arquivo referente ao certificado poderá ser incorporado.");
            this.loading = false;
        }
    }

    dismiss() {
        this.objetoRetorno.flag = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    onModuloClose() {

        if (this.comboModulos.length > 0) {
            let modString = this.comboModulos[0].idModuloPca;

            if (this.comboModulos.length > 1) {
                for (let i = 1; i < this.comboModulos.length; i++) {
                    modString += ',' + this.comboModulos[i].idModuloPca;
                }
            }

            this.autuacao.modulos = this.comboModulos;

        } else {
            this.loading = false;
        }
    }

    carregarModal() {
        this.listarArquivosPCA();
    }

    baixarArquivo(arquivo) {
        this.loading = true;
        this.fileService.baixarArquivo(arquivo);
        this.loading = false;
    }

    fileChange(event) {
        let arquivoErro: string = "";
        let arquivoOk: string = "";
        this.alertService.mostraModalConfirmacao("Salvar Peça", "Arquivo selecionado, confirma importação ?", callback => {
            if (callback) {

                let fileList: FileList = event.target.files;

                if (fileList.length > 0) {
                    for (let i = 0; i < fileList.length; i++) {
                        let file: File = fileList[i];

                        this.fileService.salvarPecaFile(file, 0, this.idModuloPCA, 0, 0, this.tipoDocumento, 'NA').subscribe(data => {

                            this.carregarModal();
                            if (i === fileList.length - 1) {
                                this.alertService.mostraAlerta("", "Certificado adicionado com sucesso.");
                            }

                        }, error => {
                            if (i === fileList.length - 1) {
                                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar o certificado.");
                            }
                        });
                    }
                }

                this.carregarModal();
            }
        });
    }

    deletarArquivo(idArquivo, nomeArquivo) {
        this.loading = true;
        this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + nomeArquivo + "?",
            retornoModal => {
                if (retornoModal) {
                    this.fileService.deletarArquivo(idArquivo).subscribe(data => {
                        this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
                        this.carregarModal();
                        this.loading = false;
                    }, error => {
                        this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
                        this.loading = false;
                    });
                }
            }
        );
    }

    assinarArquivos(arquivo) {
        this.loading = true;
        // Assinar arquivo
        let assinar = this.AGORA.assinarArquivos(arquivo.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf,this.usuarioService.obterDadosUsuario().perfil);
        assinar.subscribe(
            next => {
                console.log('Sucesso: %s', next);
                this.loading = false;
                this.dismiss();
            },
            error => {
                console.log('Erro: %s', error);
                this.alertService.mostraAlerta("Erro encontrado", error);
                this.loading = false;
            });

    }

    exibirAssinantes(myEvent, assinantes) {
        this.loading = true;
        let options: PopoverOptions = {
            cssClass: "popover-assinantes",
            showBackdrop: false,
            enableBackdropDismiss: false
        };

        let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
        popover.present({
            ev: myEvent
        });
        this.loading = false;
    }

    listarArquivosPCA() {
        let listaTipos: any = [];

        listaTipos.push(1);

        this.arquivoService.listarArquivosVinculadosPorModuloPcaPorTipoDocumento(this.idModuloPCA, listaTipos, false).subscribe(data => {
            this.listaArquivosPCA = data;
            this.loading = false;
        }, error => {
            this.loading = false;
            this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-autuacao/modal-autuacao.ts